<template>
  <div>
    <b-form-group label-for="planName" :label="$t('system.plan.planName')">
      <b-form-input
        v-model="model.name"
        type="text"
        id="name"
        placeholder="Informe o nome do plano"
      ></b-form-input>
    </b-form-group>
    <b-form-group label-for="planValue" :label="$t('system.plan.planValue')">
      <b-form-input
        v-model="model.value"
        type="text"
        id="value"
        placeholder="Informe o valor do plano"
        v-mask="'money'"
      ></b-form-input>
    </b-form-group>
    <b-form-group label-for="typeOfPlan" :label="$t('system.plan.typeOfPlan')">
      <b-form-select v-model="model.typeOfPlan" :options="typeOfPlanOptions" />
    </b-form-group>
    <b-form-group
      label-for="typeOfContract"
      :label="$t('system.plan.typeOfContract')"
    >
      <b-form-select
        v-model="model.typeOfContract"
        :options="typeOfContractOptions"
      />
    </b-form-group>
    <b-row>
      <b-col>
        <b-form-group
          label-for="franchise"
          :label="$t('system.plan.franchise')"
        >
          <b-form-input
            v-model="model.franchise"
            type="number"
            id="name"
            v-mask="'999999999999999'"
            @input="onchangeInt"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label-for="qntVehicle"
          :label="$t('system.plan.qntVehicle')"
        >
          <b-form-input
            v-model="model.qntVehicle"
            type="number"
            id="name"
            v-mask="'999999999999999'"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group label-for="blocks" label="Bloquear?">
          <b-form-select v-model="model.blocks" :options="optBlocks" />
        </b-form-group>
      </b-col>
    </b-row>

    <!-- {{ model }} -->
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
export default {
  name: "PlanCrud",
  props: {
    model: Object,
  },
  directives: {
    mask: AwesomeMask,
  },
  components: {
    SingleSelect: () => import("@/components_rms/base/SingleSelect.vue"),
  },
  data() {
    return {
      typeOfPlanOptions: [],
      typeOfContractOptions: [
        { value: 1, text: "Mensal" },
        { value: 2, text: "Anual" },
      ],
      optBlocks: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
    };
  },
  methods: {
    onchangeInt() {
      this.model.franchise = parseInt(this.model.franchise);
    },
    getAllTypeOfPlan() {
      this.$apiScheduler
        .get("plan/getAlltypesOfPlan")
        .then((response) => {
          let data = response.data;
          response.data.forEach((opt) => {
            if (opt.value != 0) {
              this.typeOfPlanOptions.push(opt);
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getAllTypeOfPlan();
  },
};
</script>

<style scoped>
/* Your component styles here */
</style>